import React, { ReactElement } from 'react';
import classNames from 'classnames';
import Spinner from 'react-bootstrap/Spinner';
import styles from '../styles.module.scss';

interface Props {
  loading: boolean;
  totalCount: number;
  selectedCount?: number;
}

const MenuTrailingBadge: React.FC<Props> = ({
  loading,
  totalCount,
  selectedCount = 0,
}): ReactElement => {
  return (
    <React.Fragment>
      {loading ? (
        <Spinner animation="border" size="sm" variant="primary" />
      ) : (
        <div
          className={classNames({
            [styles['total-count']]: true,
            [styles['selected']]: selectedCount > 0,
          })}
        >
          {selectedCount > 0 ? selectedCount : totalCount}
        </div>
      )}
    </React.Fragment>
  );
};

export default MenuTrailingBadge;
